import { useParams } from "react-router-dom";
import React, { useRef, useState, useEffect } from 'react'
import { API, Auth } from 'aws-amplify';
//import { Button,Text,View,TextField} from '@aws-amplify/ui-react';
import "@aws-amplify/ui-react/styles.css";
//import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
//import TableContainer from '../components/tablecontainer';
//import Loading from '../components/loading';
//import { FaWindowClose } from 'react-icons/fa';




import { Heading } from '@aws-amplify/ui-react';
//import { useFaceApi, } from 'react-use-faceapi';
//import {Camera} from "react-camera-pro";


const myFaceApiConfig = {
  input: 'my-image',
  refreshRate: 250,
  useFaceExpressionModel:true
}


export default function Selfie({isHomepage}) {
  let params = useParams();
  const [is_loading, updateIsLoading] = React.useState(false);
  const [res, updateRes] = useState({status:"loading...",rows:[]})
  const [count, setCount] = useState(0);
  const imageRef = useRef();
  const camera = useRef(null);
  const [image, setImage] = useState("data:image/png;base64,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"); // this image says loading, set like this to avoid many errors when null
  
  
  //temp
  //const faces = useFaceApi(myFaceApiConfig);



  const [presigned_url, updatePresignedUrl] = React.useState("");
  const [new_presigned_url_frown, updatePresignedUrlFrown] = React.useState(false);
  const [new_document_name, updateNewDocumentName] = React.useState("");
  const [selfie_smile_uploaded, updateSelfieSmileUploaded] = React.useState(false);
  const [selfie_frown_uploaded, updateSelfieFrownUploaded] = React.useState(false);
  const [selfie_verified, updateSelfieVerified] = React.useState(false);
  const [sequence_kicked_off, updateSequenceKickedOff] = React.useState(false);
  //const [sequenceCyclingInstructions, updateSequenceCyclingInstructions] = React.useState("Hold the camera far enough away to fit your entire head with some extra space.");
  const [i, updateI] = React.useState(0);
  
  //const [face_compare_result, updateFaceCompareResult] = React.useState("");
  //const [face_compare_result_2, updateFaceCompareResult2] = React.useState("");
  //const [selfie_verified_string, updateSelfieVerifiedString] = React.useState("");
  const [selfie_verified_string_2, updateSelfieVerifiedStringTwo] = React.useState("");
  //const [face_compare_response, updateFaceCompareResponse] = React.useState("");
  const [interval_id, updateIntervalId] = React.useState("");
  const [response_error, updateResponseError] = React.useState("");
  const [previous_upload_error, updatePreviousUploadError] = React.useState("");
  
  


  async function fetchSelfieVerified() {
    updateIsLoading(true)
    try {
        let session = await Auth.currentSession()      
        let accessToken = session.getAccessToken()
        let jwt = accessToken.getJwtToken()
        const myInit = {queryStringParameters:{ 
            "api_endpoint": "api3:staff:selfie", 
            "back_end": process.env.REACT_APP_BACKEND,
            "jwt":jwt
        }};
        const res = await API.get('adminWebTools','/ago',myInit)
        console.log('fetchSelfieVerified: ' + JSON.stringify(res));
        updateRes(res)
        updatePresignedUrl(res["new_presigned_url"]);
        updatePresignedUrlFrown(res["new_presigned_url_frown"]);
        updateNewDocumentName(res["new_document_name"]);
        console.log('updating selfie_smile_uploaded: ' + selfie_smile_uploaded);
        console.log('updating selfie_frown_uploaded: ' + selfie_frown_uploaded);
        updateSelfieSmileUploaded(res["selfie_smile_uploaded"]);
        updateSelfieFrownUploaded(res["selfie_frown_uploaded"]);
        updateSelfieVerified(res["selfie_verified"]);
        updatePreviousUploadError(res["previous_upload_error"]);
    }
    catch (e) {
        //const res = {status:"Error retrieving User information - email us at info@joinago.com: "+toString(e)}
        //updateRes(res)
    }
    updateIsLoading(false)
  }

  useEffect(() => {
    fetchSelfieVerified();
  },[count])

  useEffect(() => {
    //tryCheckPhoto();  temp
  },[image])



  async function submitUpload() {
    if(is_loading==false)
    {
      updateIsLoading(true);
      let session = await Auth.currentSession();
      const res = {status:"loading...",rows:[]};
      updateRes(res);
      try {
        fetch(image).then(res3 => {
          res3.blob().then(imageBlob => {
            fetch(presigned_url, {
                method:'PUT',
                body:imageBlob,
                headers: {
                    'Access-Control-Allow-Headers': '*',
                    'Access-Control-Allow-Origin': '*'
                }
            }).then((res2) => {
                let accessToken = session.getAccessToken()
                let jwt = accessToken.getJwtToken()
                const myInit = {queryStringParameters:{ api_endpoint: "api3:staff:selfie", back_end: process.env.REACT_APP_BACKEND, jwt:jwt, document_name:new_document_name}};
                try {
                    API.get('adminWebTools','/ago',myInit).then((res) => {
                        updateRes(res);
                        fetchSelfieVerified();
                        setImage("")
                        console.log('submit smile photo response: ' + JSON.stringify(res));
                        return
                    });
                } catch (e) {
                    var statusString = "Error uploading image: " + e;
                    updateRes(statusString);
                    return
                }
            })
            updateIsLoading(false);
          })
        })
      } catch (e) {
        var statusString = "Error uploading image: " + e;
        updateRes(statusString);
        updateIsLoading(false);
      }
    }
  }

  async function resetSelfies() {
    console.log('resetting selfies...');
    let session = await Auth.currentSession(); 
    let accessToken = session.getAccessToken();
    let jwt = accessToken.getJwtToken();
    const myInit = {queryStringParameters:{ api_endpoint: "api3:staff:selfie", back_end: process.env.REACT_APP_BACKEND, jwt:jwt, action:'reset'}};
    try {
        API.get('adminWebTools','/ago',myInit);
    } catch (e) {
      //var statusString = "Error: " + e;
      //updateRes(statusString);
      //return
    }
  }

  async function submitUploadFrown() {
    if(is_loading==false)
    {
      updateIsLoading(true)
      let session = await Auth.currentSession() 
      const res = {status:"loading...",rows:[]};
      updateRes(res);
      try {
        fetch(image).then(res3 => {
          res3.blob().then(imageBlob => {
            fetch(new_presigned_url_frown, {
                method:'PUT',
                body:imageBlob,
                headers: {
                    'Access-Control-Allow-Headers': '*',
                    'Access-Control-Allow-Origin': '*'
                }
            }).then((res2) => {
                let accessToken = session.getAccessToken()
                let jwt = accessToken.getJwtToken()
                const myInit = {queryStringParameters:{ api_endpoint: "api3:staff:selfie", back_end: process.env.REACT_APP_BACKEND, jwt:jwt, document_name:new_document_name, document_type:'frown'}};
                try {
                    API.get('adminWebTools','/ago',myInit).then((res3) => {
                        if(res3['status']=='success'||res3['status']=='Your file was successfully uploaded.')
                        {
                          console.log('selfie frown submit response:' + JSON.stringify(res3));
                          //updateRes(res);
                          if(res3['selfie_verified_string_2']!=='')
                          {
                            updateSelfieVerifiedStringTwo(res3['selfie_verified_string_2']);
                          }
                          //updateFaceCompareResult(res3['face_compare_result']);
                          //updateFaceCompareResult2(res3['face_compare_result_2']);
                          //updateFaceCompareResponse(res3);
                          updateSequenceKickedOff(false);
                          clearInterval(interval_id);
                          updateSelfieSmileUploaded(false);
                          updateSelfieFrownUploaded(false);
                          fetchSelfieVerified();
                          setImage("");
                          if(typeof isHomepage==='boolean')
                          {
                            if(isHomepage)
                            {
                              window.location.reload();
                            }
                          }
                          return
                        } else {
                          if(res3['status']=='in progress')
                          {
                            // this was a duplicate, take no action
                          } else {
                            // there must have been an error, they failed
                            console.log(JSON.stringify(res3));
                            //updateRes(res);
                            if(res3['selfie_verified_string_2']!=='')
                            {
                              updateSelfieVerifiedStringTwo(res3['selfie_verified_string_2']);
                            }
                            //updateFaceCompareResult(res3['face_compare_result']);
                            //updateFaceCompareResult2(res3['face_compare_result_2']);
                            //updateFaceCompareResponse(res3);
                            updateSequenceKickedOff(false);
                            clearInterval(interval_id);
                            updateSelfieSmileUploaded(false);
                            updateSelfieFrownUploaded(false);
                            fetchSelfieVerified();
                            setImage("");
                            updateResponseError(res3['status']);
                            return
                          }
                        }
                    });
                } catch (e) {
                    var statusString = "Error uploading image: " + e;
                    updateRes(statusString);
                    return
                }
            })
            updateIsLoading(false);
          })
        })
      } catch (e) {
        var statusString = "Error uploading image: " + e;
        updateRes(statusString);
        updateIsLoading(false);
      }
    }
  }


  /*
  function tryCheckPhoto()
  {
    console.log('checking photo...');
    if(faces.length > 0)
    {
      console.log('face identified');
      if(selfie_smile_uploaded)
      {
          //  This is shocked
          if(Math.round(faces[0]["expressions"]["happy"]*100,2) < 50)
          {
            // shocked success! Submit
            submitUploadFrown();
            updateI(0);
          }
      } else {
          // this is smile
          if(Math.round(faces[0]["expressions"]["happy"]*100,2) > 51)
          {
            // smile success! Submit
            submitUpload();
            updateI(0);
          }
      }
    } else {
      console.log('No face identified');
    }
  }

  */



  async function executeInterval()
  {
    console.log('taking photo...');
    await setImage(camera.current.takePhoto());
  }

  async function startInterval()
  {
    console.log('selfie_smile_uploaded: ' + selfie_smile_uploaded);
    console.log('selfie_frown_uploaded: ' + selfie_frown_uploaded);
    if(selfie_smile_uploaded && selfie_frown_uploaded)
    {
      updateSelfieSmileUploaded(false);
      updateSelfieFrownUploaded(false);
      await resetSelfies();
    }
    if(selfie_frown_uploaded==true && selfie_smile_uploaded==false)
    {
      updateSelfieSmileUploaded(false);
      updateSelfieFrownUploaded(false);
      await resetSelfies();
    }
    var intervalId = updateSequenceKickedOff(true);
    updateIntervalId(intervalId);
    setInterval(executeInterval.bind(this), 2200);
  }

  const renderSelfieVerified = () => {
    if(is_loading){
      return (
        <p>Loading...</p>
      )
    }
    if(!res['selfie_verified_string']){
      return (
        <p>Your selfies didn't seem to match your driver's license. Please use the navigation menu on the left to check your license picture to ensure it isn't blurry, then come back and try again.</p>
      )
    }
    return (
     <p>{res['selfie_verified_string']}</p>
    )
  }

  var StencilSmile = undefined
  var StencilShock = undefined

  return (
    <main style={{ padding: "1rem" }}>
      <h1>In Development</h1>
      <p>Please use the mobile app.</p>
    </main>
  );
}

/*
      <div style={{display:'none'}}><img style={{ width: 400 }} ref={imageRef} id="my-image" src={image} /></div>
      {sequence_kicked_off ? 
        <div>
            <Camera ref={camera} />
            <div style={{position:'fixed', bottom:0, left:'-10px', width:'120%', maxWidth:'800px', zIndex:10, alignItems:'center', justifyContent:'center', background: '#000', display:'flex', opacity:'0.8', padding:10}}>
              <div style={{backgroundColor:'#e6e9f0', paddingTop:15, paddingBottom:10, paddingRight:25, paddingLeft:25}}>
                {selfie_smile_uploaded ? 
                  selfie_frown_uploaded ? 
                  <div>
                    <h3 style={{textAlign:'center'}}>Comparing with License...</h3>
                  </div>
                  :
                  <div>
                    <h3 style={{textAlign:'center'}}>LOOK SHOCKED!</h3>
                    {faces.length > 0 ? 
                      Math.round(faces[0]["expressions"]["happy"]*100,2) < 50 ? 
                      <p style={{textAlign:'center'}}>Hold that pose!</p>
                       : 
                      <div>
                        <p style={{textAlign:'center'}}>We detect your face,<br/> but you don't look shocked.<br/><br/>Try wide-eyed, open-mouthed disbelief!</p>
                      </div>
                      :
                    <p style={{textAlign:'center'}}>We haven't detected your face yet.</p>}
                  </div>
                  :

                  <div>
                    <h3 style={{textAlign:'center'}}>SMILE!</h3>
                    {faces.length > 0 ? 
                      Math.round(faces[0]["expressions"]["happy"]*100,2) > 55 ? 
                        <p style={{textAlign:'center'}}>Keep smiling!</p>
                         : 
                         <p style={{textAlign:'center'}}>We detect your face,<br/> but you aren't smiling.<br/><br/>Try laughing!</p>
                       :
                      <p style={{textAlign:'center'}}>We haven't detected your face yet.</p>}
                  </div>
                }
                

              </div>
            </div>
            {
              selfie_smile_uploaded ? 
                selfie_frown_uploaded ? 
                  undefined
                : 
                  faces.length > 0 ? 
                    Math.round(faces[0]["expressions"]["happy"]*100,2) < 50 ? 
                      undefined
                    : 
                      StencilShock
                  : 
                  StencilShock
              : 
                faces.length > 0 ? 
                  Math.round(faces[0]["expressions"]["happy"]*100,2) > 55 ? 
                    undefined
                      : 
                    StencilSmile
                :
                  StencilSmile
            }
        </div>
      :
        <div>
          <Heading level={2}>Selfie Verification</Heading>
          {renderSelfieVerified()}
          {selfie_verified_string_2}
          <br/>{response_error}
          <br/>
          {selfie_verified ? undefined : is_loading ? undefined : response_error == '' ? previous_upload_error !== '' ? <div><p>{previous_upload_error}</p><p><button style={{paddingTop:5, paddingBottom:5, paddingLeft:30, paddingRight:30, backgroundColor:"#092F50",color:"#fff", borderRadius:5}} onClick={() => startInterval()}>TRY AGAIN</button></p></div> : <p><button style={{paddingTop:5, paddingBottom:5, paddingLeft:30, paddingRight:30, backgroundColor:"#092F50",color:"#fff", borderRadius:5}} onClick={() => startInterval()}>I'M READY!</button></p> : <p><button style={{paddingTop:5, paddingBottom:5, paddingLeft:30, paddingRight:30, backgroundColor:"#092F50",color:"#fff", borderRadius:5}} onClick={() => window.location.reload()}>TRY AGAIN</button></p>}

        </div>
      }
*/